/* eslint-disable @remind/remind/no-on-functions */
/* @flow */
import CenteredContainer from 'components/CenteredContainer';
import GoogleConversionConstants from 'constants/GoogleConversionConstants';
import GroupActions from 'groups/actions/GroupActions';
import * as React from 'react';
import RolePicker from 'components/RolePicker';
import ToastActions from 'actions/ToastActions';
import UserActions from 'user/UserActions';
import View from 'components/View';

type Props = {
  params: {
    groupCode?: string,
  },
  router: Object,
};

class JoinRolePicker extends React.Component<Props> {
  componentDidMount() {
    if (window.google_trackConversion) {
      window.google_trackConversion(GoogleConversionConstants.SIGN_UP);
    }

    if (window.fbq) {
      window.fbq('track', 'PageView');
      window.fbq('track', 'CompleteRegistration');
    }
  }

  onSelect = (role: string) => {
    const { params, router } = this.props;

    const onUserUpdateError = () => {
      ToastActions.showDefaultErrorToast();
    };

    const onUserUpdateSuccess = () => {
      const transitionOut = () => {
        if (params.groupCode) {
          router.push(`/information_required/${params.groupCode}`);
        } else {
          router.push('/classes?origin=subscribed');
        }
      };

      if (!params.groupCode) {
        transitionOut();
        return;
      }

      const onSubscriptionError = error => {
        const expected = ['duplicate_membership', 'information_required', 'archived'].includes(
          error.code
        );
        if (expected) {
          transitionOut();
        } else {
          ToastActions.showDefaultErrorToast();
          console.warn('Join Role Picker: failed to join group', error);
        }
      };

      GroupActions.subscribeToGroupWithCode(params.groupCode).then(
        transitionOut,
        onSubscriptionError
      );
    };

    UserActions.update({ role }).then(onUserUpdateSuccess, onUserUpdateError);
  };

  render() {
    return (
      <CenteredContainer full>
        <View>
          <RolePicker onSelect={this.onSelect} />
        </View>
      </CenteredContainer>
    );
  }
}

export default JoinRolePicker;
